import React, { useState, useContext } from "react";
import MoglixLogo from "@assets/images/logo.svg";
import Menu from "./Menu";
import { UserContext } from "@contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { triggerGaEvents } from './gtag'

export default function Header() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenHelp, setIsOpenHelp] = useState(false);
  const { user, setUser } = useContext(UserContext);

  const handleLogout = () => {
    triggerGaEvents('logout');
    setUser({});
    localStorage.clear();
    navigate("/login");
  };

  const handleHelp = () => {
    const newState = !isOpenHelp;
    setIsOpenHelp(newState);
    setIsOpen(false);
    triggerGaEvents('help', { open: newState });
  }

  const handleProfile = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    setIsOpenHelp(false);
    triggerGaEvents('profile', { open: newState });
  }

  return (
    <header>
      <nav className="bg-white border-gray-200 relative mobile:h-[70px] px-4 desktop:px-6 mb-[2px] py-2.5 dark:bg-gray-800  shadow-[0px_1px_4px_rgba(0,0,0,0.16)]">
        <div className="flex flex-wrap justify-between items-center mx-auto ">
          <div className=" flex items-center">
            <div className="mobile:hidden">
              <Menu />
            </div>
            <Link to="/" className="flex items-center mr-5">
              <img src={MoglixLogo} className="mr-3" alt="Flowbite Logo" />
            </Link>
            {/* <div className="relative flex items-center mobile:absolute mobile:bottom-[12px] mobile:w-[330px] w-[535px] rounded-full border border-gray-300 bg-white shadow-sm">
              <input type="text" placeholder="Search By..." className="w-full rounded-full px-4 py-2 text-sm bg-[#EFEFF4] text-gray-600 focus:outline-none" />
              <button type="button" className="absolute right-0 flex h-full items-center justify-center rounded-r-full bg-red-500 px-4 text-white">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 4a7 7 0 1 1-4.95 11.95l-3.57 3.57a1 1 0 0 1-1.41-1.41l3.57-3.57A7 7 0 0 1 11 4z" />
                </svg>
              </button>
            </div> */}
          </div>
          <div className="flex items-center lg:order-2">
            <div className="relative z-40">
              <button onClick={handleProfile} title="profile" className="w-[34px] h-[34px] flex items-center justify-center text-gray-800 dark:text-white bg-[#EFEFF4]  focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_496_33324)">
                    <path d="M12.001 22.0016C9.34948 21.9991 6.80735 20.9448 4.93223 19.0702C3.05711 17.1955 2.0022 14.6535 1.99902 12.002C2.0022 9.35039 3.05699 6.80811 4.93208 4.93325C6.80716 3.05839 9.34937 2.00408 12.001 2.00122C14.6523 2.0044 17.1941 3.05898 19.0687 4.93384C20.9433 6.8087 21.9977 9.35071 22.0006 12.002C21.9977 14.6532 20.9432 17.1949 19.0686 19.0696C17.1939 20.9443 14.6522 21.9988 12.001 22.0016ZM12.001 3.95005C9.86655 3.95227 7.82014 4.80116 6.31064 6.31021C4.80115 7.81925 3.95188 9.86523 3.94902 11.9997C3.95156 14.1344 4.80071 16.1808 6.3102 17.6903C7.8197 19.1998 9.86623 20.0491 12.001 20.0516C14.1354 20.0488 16.1815 19.1992 17.6906 17.6897C19.1996 16.1802 20.0484 14.1341 20.0506 11.9997C20.048 9.86555 19.1992 7.81983 17.6901 6.31079C16.1811 4.80175 14.1351 3.95259 12.001 3.95005Z" fill="#3C3C3C"></path>
                    <path d="M5.86328 15.4172C6.50851 16.4769 7.40729 17.3594 8.4786 17.9851C9.54992 18.6109 10.7601 18.9602 12.0001 19.0016C13.2401 18.9605 14.4504 18.6113 15.5218 17.9856C16.5932 17.3598 17.4919 16.4771 18.1369 15.4172C16.4709 13.8645 14.2781 13.0011 12.0007 13.0011C9.72325 13.0011 7.52931 13.8645 5.86328 15.4172ZM11.8405 11.0012C12.4338 11.0012 13.0138 10.8253 13.5072 10.4956C14.0005 10.166 14.3851 9.69745 14.6121 9.14927C14.8392 8.60109 14.8986 7.99789 14.7828 7.41595C14.6671 6.83401 14.3814 6.29946 13.9618 5.8799C13.5422 5.46034 13.0077 5.17462 12.4258 5.05887C11.8438 4.94311 11.2406 5.00252 10.6924 5.22958C10.1443 5.45665 9.67572 5.84116 9.34607 6.33451C9.01643 6.82786 8.84048 7.40788 8.84048 8.00122C8.84048 8.79687 9.15655 9.55993 9.71916 10.1225C10.2818 10.6852 11.0448 11.0012 11.8405 11.0012Z" fill="#3C3C3C"></path>
                  </g>
                  <defs>
                    <clippath id="clip0_496_33324">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.00195312)"></rect>
                    </clippath>
                  </defs>
                </svg>
              </button>
              {isOpen && (
                <ul className="absolute mobile:left-[-55px] left-[-80px] w-[225px] mt-2  bg-white border rounded-md shadow-lg">
                  <li className={`px-4 py-2 cursor-pointer hover:bg-gray-100 border-b`}>
                    <span
                      title={((user?.firstName?.trim() || "") + " " + (user?.lastName?.trim() || "")).trim() || "Unknown"}
                      className="block text-[14px] overflow-hidden whitespace-nowrap truncate">
                      {((user?.firstName?.trim() || "") + " " + (user?.lastName?.trim() || "")).trim() || "Unknown"}
                    </span>
                    <span title={user.email || "N/A"} className="block text-[12px] text-[#696969] overflow-hidden whitespace-nowrap truncate">
                      {user.email || "N/A"}
                    </span>
                  </li>
                </ul>
              )}
            </div>
            <button onClick={handleLogout} title="Logout" className="w-[34px] h-[34px] flex items-center justify-center text-gray-800 dark:text-white bg-[#EFEFF4]  focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(60,60,60,1)">
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2713 2 18.1757 3.57078 20.0002 5.99923L17.2909 5.99931C15.8807 4.75499 14.0285 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.029 20 15.8816 19.2446 17.2919 17.9998L20.0009 17.9998C18.1765 20.4288 15.2717 22 12 22ZM19 16V13H11V11H19V8L24 12L19 16Z"></path>
              </svg>
            </button>
            <div className="relative z-40">
              <button onClick={handleHelp} title="Help" className="w-[34px] h-[34px] flex items-center justify-center text-gray-800 dark:text-white bg-[#EFEFF4]  focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M12 14a4 4 0 10-4-4m4 0v.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
              {isOpenHelp && (
                <ul className="absolute mobile:left-[-55px] left-[-150px] w-[215px] mt-2 bg-white border rounded-md shadow-lg">
                  <li className="px-4 py-2 hover:bg-gray-100 border-b">
                    <a
                      href="https://moglilabs.freshservice.com/support/home"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Freshservice Support"
                      className="block text-[14px] text-blue-600 hover:underline truncate"
                    >
                      Freshservice Support
                    </a>

                    <a
                      href="mailto:moglix-support@moglix.com"
                      title="moglix-support@moglix.com"
                      className="flex items-center gap-1 text-[12px] text-[#696969]"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-4 h-4 text-gray-500 shrink-0"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3 8.25L12 13.5l9-5.25M4.5 6h15a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 16.5v-9A1.5 1.5 0 014.5 6z"
                        />
                      </svg>

                      <span className="truncate">moglix-support@moglix.com</span>
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
